module.exports = {
  'account.footer.copyright': '© 2018 - 2019 Binance.org. Tüm hakları saklıdır.',
  'account.footer.copyright.trubi': '© 2018 - 2019 Trubi. Tüm hakları saklıdır.',
  'account.footer.exchange': 'Borsa',
  'account.footer.home': 'Anasayfa',
  'balances.filteredByAsset': 'Varlığa göre filtrelenmiş',
  'balances.hideZeroBalance': 'Sıfır Bakiyeleri Gizle',
  'balances.myBalances': 'Bakiyelerim',
  'blocked.country.list':
    "Amerika Birleşik Devletleri, Arnavutluk, Bosna Hersek, Belarus, Kongo (DKC), Côte d'Ivoire, Kırım, Küba, Irak, İran, Kuzey Kore, Liberya, Makedonya, Myanmar, Sırbistan, Sudan, Suriye, Zimbabwe.",
  'common.cancel': 'İptal et',
  'common.close': 'Kapat',
  'common.confirm': 'Onayla ',
  'common.connect': 'Bağlan',
  'common.continue': 'Devam et',
  'common.errorOccured': 'bir hata oluştu',
  'common.goBack': 'Geri Git',
  'common.googleUnlock': 'Google Drive',
  'common.keystoreFile': 'Keystore Dosyası',
  'common.ledgerDevice': 'Ledger Aygıtı',
  'common.loading': 'Yükleniyor',
  'common.mnemonicPhrase': 'Kurtarma Cümlesi',
  'common.networkError': 'Ağ Hatası',
  'common.or': 'ya da',
  'common.password': 'Şifre',
  'common.placeOrder': 'Teklif Ver',
  'common.pleaseCheckVisitWebsite': 'Lütfen bu adresi ziyaret ettiğinizden emin olun ',
  'common.previous': 'Önceki',
  'common.privateKey': 'Özel Anahtar',
  'common.systemError': 'Sistem Hatası',
  'common.trezorDevice': 'Trezor Aygıtı',
  'common.viewMyPrivateKey': 'Özel Anahtarımı Görüntüle',
  'common.viewOnly': 'Yalnızca Görüntülenebilir',
  'common.walletConnect': 'Mobil Cüzdan',
  'common.yes': 'Evet',
  'common.warning': 'Warning',
  'create.backupKeystore.backupYour': 'Yedekleyin ',
  'create.backupKeystore.cannotRecoveredIt': 'Eğer kaybederseniz geri alamazsınız.',
  'create.backupKeystore.createBackupFile': 'Bu dosyanın bir yedeğini oluşturun!',
  'create.backupKeystore.downloadKeystoreFile': 'Keystore Dosyasını İndir (UTC/JSON)',
  'create.backupKeystore.getMyPrivateKey': 'Özel Anahtarımı Al',
  'create.backupKeystore.keystoreFile': 'Keystore Dosyası',
  'create.backupKeystore.needFirstDownload': 'Önce keystore dosyasını indirmeniz gerekiyor',
  'create.backupKeystore.notShareFile':
    'Bu dosyayı doğrulanmamış hiçbir web sitesinde paylaşmayın ya da kullanmayın. Aksi takdirde fonlarınızı çalınma riski altına sokarsınız.',
  'create.backupMnemonic.note':
    'Aşağıdaki metni bir kağıda kaydedin ve bu kağıdı gizli ve güvenli bir yerde saklayın.',
  'create.backupMnemonic.title': 'Lütfen hatırlatma cümlesini yedekleyin',
  'create.backupText':
    'Aşağıdaki metni bir kağıda kaydedin ve bu kağıdı gizli ve güvenli bir yerde saklayın.',
  'create.chooseKSOrMnemonic.keystoreAndPassword': 'Keystore Dosyası + Şifre',
  'create.chooseKSOrMnemonic.keystoreFile': 'Keystore Dosyası',
  'create.chooseKSOrMnemonic.recommendedUSBDrive':
    'Bir USB sürücüsünde yedeklenmesi tavsiye edilir',
  'create.chooseKSOrMnemonic.recommendedUSBDriveOrPaper':
    'Bir USB sürücüsünde ya da kağıda yazılarak yedeklenmesi tavsiye edilir',
  'create.chooseKSOrMnemonic.title': 'Yeni cüzdanınızı nasıl yaratmak istersiniz?',
  'create.chooseKSOrMnemonic.unlockExistWallet': 'Varolan Bir Cüzdanın Kilidini Açın',
  'create.chooseKSOrMnemonic.useKeystoreFile':
    'Cüzdanınıza erişmek için Keystore Dosyanızı (UTC / JSON) + Şifrenizi kullanın',
  'create.chooseKSOrMnemonic.useMnemonicPhrase':
    'Cüzdanınıza erişmek için 24-kelimelik Hatırlatma Cümlesini kullanın',
  'create.confirmNote': 'Hatırlatma Cümlenizi not ettiğinizden emin misiniz?',
  'create.createNewWallet': 'Yeni Cüzdan Oluştur',
  'create.doubleConfirmMnemonic.note':
    'Elinizdeki kopyanın doğru olduğundan emin olmak için lütfen Hatırlatma Cümlesini doğru sıralamayla seçin.',
  'create.doubleConfirmMnemonic.title': 'İkincil Erişimi Seçin',
  'create.doubleConfirmMnemonic.tryAgain':
    'Yanlış Hatırlatma Cümlesi sıralaması. Lütfen tekrar deneyin.',
  'create.downloadKeyStoreFile': 'Keystore Dosyasını İndir',
  'create.enterPassword': 'Bir Şifre Girin',
  'create.google.createWallet': 'Cüzdan oluştur',
  'create.google.createdSuccessfully': 'Cüzdan Başarıyla Oluşturuldu',
  'create.google.creationFailure': 'Cüzdan Oluşturulamadı',
  'create.google.tryAgain': 'Tekrar Deneyin',
  'create.google.walletName': 'Cüzdan ismi',
  'create.googledrive.rePassErr': 'Girdiğiniz şifre uyuşmuyor',
  'create.keystoreFileAndPassword': 'Keystore Dosyası + Şifre Oluştur',
  'create.pick.useGoogleDrive.description':
    'Google hesabınızı kullanarak yeni bir cüzdan oluşturun',
  'create.pick.useGoogleDrive.title': 'Google Drive Kullanılıyor',
  'create.pick.useLocalKeystore.description':
    'Cihazınızın üzerinde saklayabileceğiniz bir cüzdan oluşturun',
  'create.pick.useLocalKeystore.title': 'Keystore Dosyası Kullanılıyor',
  'create.pleaseCheck': 'Lütfen bu adresi ziyaret ettiğinizden emin olun ',
  'create.reEnterPassword': 'Şifreyi Tekrar Girin',
  'create.stepTwo.desc':
    'Birazdan size hatırlatma cümlenizi göstereceğiz, lütfen kimsenin ekranınıza bakmadığından emin olun.',
  'create.success.desc1': 'Binance Chain Cüzdanını ve',
  'create.success.desc2': 'Merkeziyetsiz Borsayı kullanmaya hazırsınız!',
  'create.success.title': 'Hazırsınız!',
  'create.success.unlockWallet': 'Cüzdanın Kilidini Aç',
  'create.tutorial.next': 'Sonraki',
  'create.tutorial.skip': 'Tanıtımı Geç (Önerilmez)',
  'create.tutorial.step1.desc1':
    'Binance size Binance Chain üzerinde en iyi ve en güvenli deneyimi sunmayı hedefler. Bunu yapmak için, merkeziyetsiz borsaların nasıl çalıştığını ve kendinizi korumanız için neler yapmanız gerektiğini anlamanızı sağlamak üzere bir dakikanızı rica ediyoruz. Kullanım Şartlarının tamamına buradan ulaşabilirsiniz.',
  'create.tutorial.step1.title': 'Hedefimiz',
  'create.tutorial.step2.desc1':
    'Fonlarınızı tutmanın tüm sorumluluğu size ait. Başka hiç kimse, Binance bile, eğer kaybederseniz cüzdanınızı geri getirmede size yardımcı olamaz.',
  'create.tutorial.step2.desc2':
    'Binance üzerinde bir cüzdan yarattığınızda size 3 farklı format sunulur ve bu formatların her birini cüzdanınıza erişmek için kullanabilirsiniz.',
  'create.tutorial.step2.title': 'Fonlarınızı Tutmak',
  'create.tutorial.step3.desc1':
    'Keystore dosyasını bir "Kullanıcı Kimliği" olarak düşünebilirsiniz. Şifreniz de cüzdanınızı açar. Cüzdanınıza erişebilmeniz için ikisi de gereklidir, bu yüzden bunları güvende tutmalısınız. Bu Binance\'in zorunlu kıldığı formattır.',
  'create.tutorial.step3.title': 'Keystore Dosyası + Şifre',
  'create.tutorial.step4.desc1':
    '24 kelime hem "Kullanıcı Kimliği" hem de şifredir. Keystore dosyanızı kaybetmeniz ya da şifrenizi unutmanız durumunda cüzdanınıza erişmek için ikinci yoldur. Hatırlatma cümlenizi bilen herhangi biri cüzdanınıza girebilir, bu yüzden cümleyi güvende tutmalısınız.',
  'create.tutorial.step4.title': 'Hatırlatma Cümlesi',
  'create.tutorial.step5.desc1': 'Hatırlatma cümlesi kelimelerinin farklı bir temsilidir.',
  'create.tutorial.step5.desc2':
    'Binance tüm kullanıcıları için keystore dosyası + şifreyi zorunlu kılar; ikincil yöntem olarak hatırlatma cümlesi ya da özel anahtar arasından seçim yapılır.',
  'create.tutorial.step5.title': 'Özel anahtar',
  'create.tutorial.title': 'Cüzdan Yaratma Rehberi',
  'create.tutorial.understand': 'Anladım',
  'create.understandCheckbox':
    "Binance'in şifremi ya da keystore dosyamı kurtaramayacağını ya da sıfırlayamayacağını anladım. Keystore dosyamın/şifremin yedeğini yapacak, bunları güvende tutacak, tüm cüzdan yaratma adımlarını tamamlayacağım ve tüm şartları ",
  'create.understandCheckbox.terms': 'kabul ediyorum',
  'create.unlockExistWallet': 'Varolan Bir Cüzdanın Kilidini Aç',
  'create.yourKeyStore': "Keystore'unuz",
  'editWallet.remove': 'Kaldır',
  'editWallet.remove.desc1': 'Lütfen cüzdanda para olmadığından emin olun',
  'editWallet.remove.desc2': 'çünkü cüzdanı geri getirmek mümkün değil',
  'editWallet.remove.removeButton': 'Evet, bu cüzdanı kaldır',
  'editWallet.remove.title': 'Bu cüzdanı kaldırmak istediğinizden emin misiniz?',
  'editWallet.rename': 'İsmini değiştir',
  'editWallet.rename.duplicateName': 'Cüzdan ismi kayıtlı',
  'editWallet.rename.errMsg': 'İsim boş bırakılamaz',
  'editWallet.rename.title': 'Cüzdan ismi',
  'editWallet.title': 'Cüzdan İsmi',
  'editWallet.createWallet': 'Cüzdan Oluştur',
  'editWallet.unlockWallet': 'Cüzdanın Kilidini Aç',
  'exchange.BTCValue': 'BTC Değeri',
  'exchange.amount': 'Miktar',
  'exchange.asset': 'Varlık',
  'exchange.availableBalance': 'Kullanılabilir Bakiye',
  'exchange.blockHeight': 'BlokYüksekliği',
  'exchange.buy': 'Al',
  'exchange.calendar.clear': 'Temizle',
  'exchange.calendar.ok': 'Tamam',
  'exchange.calendar.today': 'Bugün',
  'exchange.chartbox.depth': 'Derinlik',
  'exchange.coin': 'Coin',
  'exchange.date': 'Tarih',
  'exchange.estimatedValue': 'Tahmini Değer',
  'exchange.filled': 'Gerçekleştirilen',
  'exchange.from': 'Kimden',
  'exchange.frozen': 'Dondurulmuş',
  'exchange.hideAllCanceled': 'İptal edilenlerin tümünü gizle',
  'exchange.hideOtherPairs': 'Diğer Çiftleri Gizle',
  'exchange.inOrder': 'İşlemde',
  'exchange.index.books': 'Defterler',
  'exchange.index.chart': 'Grafik',
  'exchange.max': 'Maks',
  'exchange.min': 'Minimum alım satım birimi:',
  'exchange.name': 'İsim',
  'exchange.notional': 'Nosyonel',
  'exchange.oneDay': '1 Gün',
  'exchange.oneMonth': '1 Ay',
  'exchange.oneWeek': '1 Hafta',
  'exchange.pair': 'Çift',
  'exchange.placeOrder.bestAsk': 'En İyi Satış Fiyatı',
  'exchange.placeOrder.bestBid': 'En İyi Alış Fiyatı',
  'exchange.placeOrder.limitOrder': 'Limit Teklifi',
  'exchange.placeOrder.noEnoughBalance': 'yeterli bakiye yok',
  'exchange.placeOrder.orderError': 'Teklif Hatası',
  'exchange.placeOrder.orderPriceHigher':
    'Teklif fiyatınız güncel piyasa fiyatından % 2 daha yüksek olacak. Lütfen dikkatle devam edin.',
  'exchange.placeOrder.orderPriceLow':
    'Teklif fiyatınız güncel piyasa fiyatından % 2 daha düşük olacak. Lütfen dikkatle devam edin.',
  'exchange.placeOrder.pleaseInputCorrectAmount': 'lütfen doğru miktarı girin',
  'exchange.placeOrder.pleaseInputCorrectPrice': 'lütfen doğru fiyatı girin',
  'exchange.placeOrder.roundSizeErrorMsg': "{baseAsset}'i yalnızca {lotSize} katları ile {side}",
  'exchange.placeOrder.successNotifyMsg':
    '{side}{quantity}{quoteAsset} için başarıyla bir limit teklifi oluşturdunuz',
  'exchange.placeOrder.successNotifyTitle': 'Limit {side} Teklif Oluşturuldu',
  'exchange.pleaseSelectDate': 'lütfen tarih seçin',
  'exchange.pleaseUnlockWallet.btn': 'Cüzdanın Kilidini Aç',
  'exchange.pleaseUnlockWallet.createNewWallet': 'Yeni Cüzdan Oluştur',
  'exchange.pleaseUnlockWallet.desc': 'Lütfen önce cüzdanın kilidini açın',
  'exchange.pleaseUnlockWallet.noWallet': 'Cüzdanınız yok mu?',
  'exchange.price': 'Fiyat',
  'exchange.search': 'Ara',
  'exchange.sell': 'Sat',
  'exchange.side': 'Yan',
  'exchange.status': 'Durum',
  'exchange.symbolPriceInfo.high': 'Yüksek',
  'exchange.symbolPriceInfo.lastPrice': 'Son Fiyat',
  'exchange.symbolPriceInfo.low': 'Düşük',
  'exchange.symbolPriceInfo.twentyFourHChange': '24s Değişim',
  'exchange.symbolPriceInfo.twentyFourHHigh': '24s En Yüksek',
  'exchange.symbolPriceInfo.twentyFourHLow': '24s En Düşük',
  'exchange.symbolPriceInfo.twentyFourHVolume': '24s Hacim',
  'exchange.symbolPriceInfo.vol': 'Hacim',
  'exchange.threeMonths': '3 Ay',
  'exchange.time.from': 'Kimden',
  'exchange.to': 'Kime',
  'exchange.total': 'Toplam',
  'exchange.totalBalance': 'Toplam Bakiye',
  'exchange.tradingHistory.time': 'Zaman',
  'exchange.tradingHistory.title': 'Alım Satım Geçmişi',
  'exchange.tradingPair.change': 'Değiştir',
  'exchange.tradingPair.pair': 'Çift',
  'exchange.tradingPair.price': 'Fiyat',
  'exchange.tradingPair.search': 'Ara',
  'exchange.tradingPair.volume': 'Hacim',
  'exchange.txFee': 'TxMasrafı',
  'exchange.txHash': 'TxHash',
  'exchange.type': 'Tür',
  'exchange.value': 'Değer',
  'fees.fee': 'İşlem Masrafı',
  'fees.height': 'Yükseklik',
  'fees.note': 'Not',
  'footer.terms': 'Kullanım Şartları',
  'footer.privacy': 'Privacy',
  'googledrive.create.nameExist': 'İsmi var',
  'header.balances': 'Bakiyeler',
  'header.createWallet': 'Cüzdan Oluştur',
  'header.exchange': 'Borsa',
  'header.explorer': 'Tarayıcı',
  'header.faq': 'Belgeler / SSS',
  'header.feeHistory': 'Masraf Geçmişi',
  'header.forums': 'Forumlar',
  'header.mainnet': 'Mainnet',
  'header.openOrders': 'Açık Teklifler',
  'header.orderHistory': 'İşlem geçmişi',
  'header.orders': 'Teklifler',
  'header.testnet': 'testnet',
  'header.tradeHistory': 'Alım Satım Geçmişi',
  'header.transactions': 'İşlemler',
  'header.unlockWallet': 'Cüzdanın Kilidini Aç',
  'header.user.changeWallet': 'Cüzdanı Değiştir',
  'header.user.closeWallet': 'Cüzdanı Kapat',
  'header.user.coinomi': 'Coinomi ',
  'header.user.copyAddress': 'adresi kopyala',
  'header.user.copySuccess': 'Kopyalama başarılı!',
  'header.user.createNewWallet': 'Yeni Cüzdan Oluştur',
  'header.user.exportKeystoreFile': 'Keystore Dosyasını Dışa Aktar',
  'header.user.goToExplorer': 'tarayıcıya git',
  'header.user.infinito': 'Infinito ',
  'header.user.ledger': 'Ledger ',
  'header.user.trezor': 'Trezor Aygıtı',
  'header.user.wallet': 'Cüzdan',
  'header.user.walletConnect': 'WalletConnect ',
  'header.youWantCloseWallet': 'Cüzdanı kapatmak istediğinizden emin misiniz?',
  'home.aboutPage.desc1.line1':
    'Binance Chain ilk olarak Binance tarafından geliştirilmiş bir blockchaindir.',
  'home.aboutPage.desc1.line2':
    'Modern, güvenli ve neredeyse anında işlem sonlandırmaya sahiptir (hızlıdır).',
  'home.aboutPage.desc2.line1': 'Binance DEX merkeziyetsiz bir teklif eşleme motorudur,',
  'home.aboutPage.desc2.line2': 'temel Binance Chain teknolojisiyle güçlendirilmiştir.',
  'home.aboutPage.desc3.line1': 'Binance DEX dijital varlıkları çıkarmak ve alıp satmak için',
  'home.aboutPage.desc3.line2':
    'modern ve güvenli bir pazar yeridir, ve anahtarlarınız yalnızca sizin elinizde olur. Favori varlıklarınızı alıp satmak hiç bu kadar güvenli olmamıştı.',
  'home.aboutPage.title': 'Binance DEX Hakkında',
  'home.binanceDex': 'Binance DEX',
  'home.processPage.aboutBalance': 'Binance DEX Hakkında',
  'home.processPage.create': 'Oluştur',
  'home.processPage.createDesc': 'İlk adım bir Binance Chain adresi oluşturmaktır.',
  'home.processPage.createWallet': 'Yeni Bir Cüzdan Oluştur',
  'home.processPage.getStart': 'Binance DEX kullanmaya başla',
  'home.processPage.go': 'Git',
  'home.processPage.placeOrders': 'Teklif Verme',
  'home.processPage.placeOrdersDesc':
    "Teklifleri göndermek ve iptal etmek için web cüzdanını ya da API'ı kullanın.",
  'home.processPage.transferAssets': 'Varlıkları Transfer Et',
  'home.processPage.transferAssetsDesc':
    "Binance Chain'i destekleyen tüm cüzdanlarla yaratılabilen Binance Chain adresi ile bu adreste tutulan BNB'leri ya da diğer varlıkları transfer edebilirsiniz.",
  'home.processPage.unlock': 'Kilidini Aç',
  'home.processPage.unlockDesc': 'Cüzdanınızın kilidini açmanın dört yolu',
  'home.processPage.unlockMode1': 'WalletConnect',
  'home.processPage.unlockMode2': 'Ledger',
  'home.processPage.unlockMode3': 'Keystore Dosyası + Şifre',
  'home.processPage.unlockMode4': 'Hatırlatma Cümlesi',
  'home.processPage.unlockWallet': 'Bir Cüzdanın Kilidini Aç',
  'home.startPage.createWallet': 'Bir Cüzdan Oluştur',
  'home.startPage.desc1': 'Hızlı ve güvenli merkeziyetsiz dijital varlık borsası',
  'home.startPage.desc2': 'Yeni kripto para alım satım standardı burada.',
  'home.startPage.getTestBNB': "Test BNB'lerini Al",
  'home.startPage.startTrading': 'Alım Satıma Başla',
  'home.whyPage.community': 'Bir Topluluk Girişimidir',
  'home.whyPage.communityDesc':
    'Binance DEX zincir üstü yönetim ve açık kaynaklı yazılım öğeleri ile güçlendirilmiştir.',
  'home.whyPage.decentralized': 'Merkeziyetsiz',
  'home.whyPage.decentralizedDesc':
    'Herhangi bir üçüncü parti ya da merkezi otorite olmadan doğrudan cüzdanlar arası alım satımı deneyimleyin.',
  'home.whyPage.getStarted': 'Başlayın',
  'home.whyPage.lowTradingFees': 'Düşük Alım Satım Masrafları',
  'home.whyPage.lowTradingFeesDesc':
    'Çekim, yatırma ve teklif verme için ücret ödemeden alım satım yapın - ve BNB sahipleri daha çok kazanç sağlıyor.',
  'home.whyPage.safeAndSecure': 'Güvenli',
  'home.whyPage.safeAndSecureDesc':
    'Fonlarınız, yalnızca sizin kontrolünüzde olan bir gizli anahtarla bir blockchain adresi üzerinde saklanır.',
  'home.whyPage.title': 'Neden Binance DEX',
  'home.whyPage.userFriendly': 'Kullanıcı Dostu',
  'home.whyPage.userFriendlyDesc':
    'Bir cüzdan oluşturun, cüzdanınızın kilidini açın ve alım satım yapmaya hazırsınız. Fon yatırmaya ya da çekmeye gerek yok.',
  'inputPassword.passwordRule': 'Şifreniz aşağıdaki özelliklere sahip olmalıdır',
  'inputPassword.passwordRule1': '8 ya da daha fazla karakter',
  'inputPassword.passwordRule2': 'Bir büyük harf, sembol ve rakam',
  'inputPassword.setANewPassword': 'Yeni bir Şifre Belirle',
  'landing.connectWallet': 'Cüzdanı Bağla',
  'landing.createWallet': 'Cüzdan Oluştur',
  'landing.desc1': 'Binance DEX',
  'landing.desc2':
    'Hızlı ve güvenli merkeziyetsiz dijital varlık borsası. Yeni kripto para alım satım standardı burada.',
  'landing.footer.fee': 'İşlem Masrafı',
  'landing.footer.terms': 'Kullanım Şartları',
  'landing.footer.privacy': 'Privacy',
  'landing.how.connect': 'Bağlan',
  'landing.how.connect.desc':
    "Binance DEX'e erişim tahmin ettiğinizden daha kolay. Bağlan düğmesine tıklayın ve bağlantı seçeneklerinden birini tercih edin. Hazırsınız.",
  'landing.how.create': 'Oluştur',
  'landing.how.create.desc':
    "Binance DEX size kullanışlı keystore'lardan ultra güvenli donanım cüzdanına kadar birçok seçenek arasından seçme özgürlüğü sunar.",
  'landing.how.step': 'adım',
  'landing.how.title': 'Nasıl kullanılır',
  'landing.how.trade': 'Alım satım',
  'landing.how.trade.desc':
    "Amacımız alım satımları sorunsuz ve Binance.com'dan farksız hale getirmek. Bunu yapmak için en iyi özellikleri optimize ettik. Böylece sevdiğiniz her şeyi Binance DEX'te de bulabileceksiniz.",
  'landing.markets': 'Piyasalar',
  'landing.markets.24HChange': '24S Değişim',
  'landing.markets.24HVolume': '24S Hacim',
  'landing.markets.lastPrice': 'Son Fiyat',
  'landing.markets.pair': 'Çift',
  'landing.markets.searchPlaceholder': 'Coin ismi ara',
  'landing.menu.balances': 'Bakiyeler',
  'landing.menu.changeWallet': 'Cüzdanı Değiştir',
  'landing.menu.closeWallet': 'Cüzdanı Kapat',
  'landing.menu.community': 'Topluluk',
  'landing.menu.copyAddress': 'adresi kopyala',
  'landing.menu.docs': 'Belgeler',
  'landing.menu.exchange': 'Borsa',
  'landing.menu.explorer': 'Tarayıcı',
  'landing.menu.orders': 'Teklifler',
  'landing.menu.orders.feeHistory': 'Masraf Geçmişi',
  'landing.menu.orders.openOrders': 'Açık Teklifler',
  'landing.menu.orders.orderHistory': 'Teklif geçmişi',
  'landing.menu.orders.tradeHistory': 'Alım Satım Geçmişi',
  'landing.menu.testnet': 'Testnet',
  'landing.menu.tools': 'Araçlar',
  'landing.menu.transaction': 'İşlem',
  'landing.menu.wallet': 'Cüzdan',
  'landing.startTrading': 'Alım Satıma Başla',
  'landing.trust.activeAddress': 'Aktif Cüzdanlar',
  'landing.trust.activeAddress.desc':
    "Birçok kişi Binance DEX'in altyapısına ve alım satım sistemlerine tüm diğer cüzdan çözümlerinden daha fazla güveniyor.",
  'landing.trust.pairs': 'Çiftler',
  'landing.trust.pairs.desc':
    'Binance DEX size daha fazla seçenek ve alım satım esnekliği sunuyor, ve bunlara her hafta yenileri ekleniyor.',
  'landing.trust.rank': 'Sıralama',
  'landing.trust.rank.desc':
    "Binance DEX, Coinmarketcap'te hacim bazında 1 numaralı merkeziyetsiz kripto para borsası.",
  'landing.trust.title': 'İnsanlar bize neden güveniyor',
  'landing.why.competitive': 'Rekabetçi',
  'landing.why.competitive.desc':
    "Alım satım masrafları için BNB kullandığınızda masraflar yalnızca %0,04. Bu oran alım satım masrafları bazından dünyanın lider borsası Binance.com'un neredeyse yarısı.",
  'landing.why.fast': 'Hızlı',
  'landing.why.fast.desc':
    "1 saniyelik blok süreleriyle blockchain alım satım doğrulamaları artık geçmişte kaldı. Olumsuz yanlar olmadan DEX'in tüm avantajlarından faydalanın.",
  'landing.why.secure': 'Güvenli',
  'landing.why.secure.desc':
    'Binance DEX güvenliği tamamen yeni bir seviyeye taşıyor. Eşler arası transferler ve alım satımlar güvenlik risklerine hiç maruz kalmamak anlamına geliyor.',
  'landing.why.title': 'Neden Binance DEX',
  'lang.menu.copyAddress': ' ',
  'noContent.descPrefix': 'Bulunmuyor ',
  'openOrders.areYourTrue': 'Emin misiniz',
  'openOrders.cancel': 'iptal et',
  'openOrders.cancel all': 'tümünü iptal et',
  'openOrders.cancel buy': 'alımı iptal et',
  'openOrders.cancel sell': 'satışı iptal et',
  'openOrders.cancelAll': 'Tümünü İptal Et',
  'openOrders.cancelBuy': 'Alımı İptal Et',
  'openOrders.cancelOrder': 'Teklifi İptal Et',
  'openOrders.cancelOrders': 'Teklifleri İptal Et',
  'openOrders.cancelPartialSuccess': 'İptal kısmen başarılı',
  'openOrders.cancelSell': 'Satışı İptal Et',
  'openOrders.cancelSuccess': 'İptal Başarılı',
  'openOrders.keepOrder': 'Teklifi Tut',
  'openOrders.keepOrders': 'Teklifleri Tut',
  'openOrders.noBuyOpenOrders': 'açık alım teklifi yok',
  'openOrders.noOpenOrders': 'açık teklif yok',
  'openOrders.noSellOpenOrders': 'açık satış teklifi yok',
  'openOrders.title': 'Açık Teklifler',
  'orderForm.amount': 'Miktar',
  'orderForm.avb': 'Kul.',
  'orderForm.buy': 'Satın al',
  'orderForm.equivalent': 'Denk gelen',
  'orderForm.price': 'Fiyat',
  'orderForm.sell': 'Sat',
  'orderForm.total': 'Toplam',
  'orderHistory.openHistory': 'teklif geçmişi',
  'orderHistory.title': 'Teklif Geçmişi',
  'orderHistory.tradeId': 'Alım Satım ID',
  'orderHistory.tradingPrice': 'Alım Satım Fiyatı',
  'orderHistory.tradingTotal': 'Alım Satım Toplamı',
  'privateKeyModal.backupText':
    'Aşağıdaki metni bir kağıda kaydedin ve bu kağıdı gizli ve güvenli bir yerde saklayın.',
  'privateKeyModal.title': 'Özel Anahtarınız',
  'testnet.binanceChainExplorerGuide': 'Binance Chain Tarayıcı Rehberi',
  'testnet.fastAndSecureDesc': 'Hızlı ve güvenli merkeziyetsiz dijital varlık borsası',
  'testnet.fundingYourTestnetAccount': 'Testnet Hesabınızı Fonlama',
  'testnet.howToAccessYourWallet': 'Cüzdanınıza Nasıl Erişebilirsiniz',
  'testnet.howToCreateAWallet': 'Bir Cüzdanı Nasıl Yaratabilirsiniz',
  'testnet.interfaceGuide': 'Arayüz Rehberi',
  'testnet.thingsToAvoid': 'Kaçınmanız Gerekenler',
  'testnet.title': 'Binance Merkeziyetsiz Borsası (TESTNET)',
  'token.issueModal.mintable': 'Kazılabilir',
  'token.issueModal.name': 'Token Adı',
  'token.issueModal.nameErrMsg': 'token adı 32 karakterle sınırlıdır',
  'token.issueModal.symbol': 'Simge',
  'token.issueModal.symbolErrMsg': 'simge alfanumerik olmalıdır ve uzunluğu 3~8 ile sınırlıdır',
  'token.issueModal.title': 'Token Çıkar',
  'token.issueModal.totalSupply': 'Toplam Arz',
  'token.issueModal.totalSupplyErrMsg': 'geçersiz arz miktarı',
  'token.listModal.address': 'Adres',
  'token.listModal.confirm': 'Onayla',
  'token.listModal.initPrice': 'Başl. Fiyatı',
  'token.listModal.proposalId': 'TeklifKimliği',
  'token.listModal.quoteAsset': 'Çevrim Varlığı',
  'token.listModal.title': 'Token Listele',
  'token.listModal.tokenName': 'Token Adı',
  'token.main.burn': 'Yak',
  'token.main.freeze': 'Dondur',
  'token.main.issueToken': 'Token Çıkar',
  'token.main.list': 'Listele',
  'token.main.listSuccessmsg': 'Listeleme başarılı',
  'token.main.mint': 'Kaz',
  'token.main.proposal': 'Teklif',
  'token.main.submitListFirst': 'Lütfen önce listeleme teklifini gönderin',
  'token.main.submitSuccessmsg': 'listeleme teklifi başarıyla gönderildi',
  'token.main.title': 'Token Listem',
  'token.main.unfreeze': 'Tekrar aç',
  'token.proposalModal.address': 'Adres',
  'token.proposalModal.baseAsset': 'Baz Varlık',
  'token.proposalModal.desc': 'Açıklama',
  'token.proposalModal.expireTime': 'Son Kullanım Zamanı',
  'token.proposalModal.hours': 'Saat',
  'token.proposalModal.initDeposit': 'İlk Yatırma',
  'token.proposalModal.initPrice': 'Başl. Fiyatı',
  'token.proposalModal.initPriceErr': 'Başlangıç fiyatı boş olmamalıdır',
  'token.proposalModal.initPriceErr2': "başlangıç fiyatı 0'dan büyük olmalıdır",
  'token.proposalModal.quoteAsset': 'Çevrim Varlığı',
  'token.proposalModal.title': 'Listeleme Teklifi',
  'token.proposalModal.titleErr': 'Teklif başlığı boş olmamalıdır',
  'token.proposalModal.titleErr2': "Teklif başlığı maks. uzunluk 128'den daha uzun",
  'token.proposalModal.votingPeriod': 'Oylama Dönemi',
  'token.table.col.mintable': 'Kazılabilir',
  'token.table.col.name': 'İsim',
  'token.table.col.symbol': 'Simge',
  'token.table.col.totalSupply': 'Toplam Arz',
  'token.tokenModal.address': 'Adres',
  'token.tokenModal.amount': 'Miktar',
  'token.tokenModal.available': 'Kullanılabilir',
  'token.tokenModal.burnTitle': 'Token Yak',
  'token.tokenModal.confirm': 'Onayla',
  'token.tokenModal.desc': ' ',
  'token.tokenModal.freezeTitle': 'Token Dondur',
  'token.tokenModal.mintTitle': 'Token Kaz',
  'token.tokenModal.name': 'İsim',
  'token.tokenModal.unfreezeTitle': 'Tokenı Tekrar Aç',
  'token.warning':
    'We do not support walletconnect compatible wallets currently and for security reason, Ledger is the best choice to Issue/List/Mint/Burn Token',
  'tradeHistory.tradeHistory': 'alım-satım geçmişi',
  'transaction.here': 'buradan',
  'transaction.notes':
    'Tüm işlemler aşağıya dahil edilmemiştir. Tam geçmişi şuradan görebilirsiniz',
  'txHistory.here': 'buradan',
  'txHistory.notEveryTransactionIsIncludedBelow':
    'Tüm işlemleri aşağıya dahil edilmemiştir. Tam geçmişi buradan görebilirsiniz.',
  'txHistory.title': 'İşlem Geçmişi',
  'unlock.connectAddress.enterYourAddress': 'Adresinizi girin',
  'unlock.connectAddress.invalidAddress': 'Geçersiz adres',
  'unlock.connectAddress.viewOnlyMode': 'Yalnızca görüntülenebilir mod için bir adres girin',
  'unlock.createNewWallet': 'Yeni Bir Cüzdan Oluştur',
  'unlock.google.chooseWallet': 'Kullanılabilir cüzdanlarınızdan birini seçin:',
  'unlock.google.logIn': 'Giriş yap',
  'unlock.google.notLoggedIn': 'Google Hesabınıza giriş yapmadınız',
  'unlock.google.signedInAs': 'Giriş yaptığınız kullanıcı adı',
  'unlock.googledrive.editWallet': 'Cüzdan Ayrıntılarını Düzenle',
  'unlock.googledrive.wallets': 'Devam etmek şu cüzdanlarınızdan birini seçin:',
  'unlock.index.selectUnlockType': 'Kilidi nasıl tekrar açmak istediğinizi seçin',
  'unlock.index.title': 'Cüzdanınızın Kilidini Açın',
  'unlock.keystore.enterYourWalletPass': 'Cüzdan şifrenizi girin',
  'unlock.keystore.paste': 'Ya da keystore dosyanızın içeriğini yapıştırın',
  'unlock.keystore.select': 'Şifreli bir cüzdan dosyasını bağlayın ve şifrenizi girin',
  'unlock.keystore.upload': 'Keystore dosyasını yükle',
  'unlock.ledger.appInstallation': 'Uygulama Kurulumu',
  'unlock.ledger.binanceChainReady': 'Binance Chain Hazır',
  'unlock.ledger.connectToLedger': "Ledger'a Bağlan",
  'unlock.ledger.enterPINCode': 'PIN Kodu Gir',
  'unlock.ledger.getTheApp': 'Uygulamayı indir',
  'unlock.ledger.havingConnectionIssues': 'Bağlantı Sorunları Mı Yaşıyorsunuz?',
  'unlock.ledger.mustBeOnScreen': 'ekran üzerinde olmalı',
  'unlock.ledger.openBinanceChain': "Binance Chain'i Aç",
  'unlock.ledger.text':
    'Ekranda görünen talimatları takip ederek donanım cüzdanınızı buraya bağlayın',
  'unlock.ledger.title': 'Bir Ledger Aygıtı ile kilidi aç',
  'unlock.ledger.usageInstructions': 'Kullanım Talimatları',
  'unlock.mnemonic.pleaseEnterYourPhrase': 'Lütfen 24 kelimelik cümlenizi girin',
  'unlock.mnemonic.pleaseSeparateEachWordSpace': 'Lütfen tüm kelimelerin arasında boşluk bırakın.',
  'unlock.mnemonic.warning.desc1':
    'Bu seçenek kayıp bir keystore dosyasını ya da şifreyi geri getirir,',
  'unlock.mnemonic.warning.desc2': 'ya da başka bir cüzdan uygulamasından tohumu içe aktarır.',
  'unlock.mnemonic.warning.desc3':
    'Uyarı! Tohum cümlenizi ya da özel anahtarınızı bir web sitesine girmeniz çok tehlikelidir. Eğer tarayıcınızda zararlı uzantılar yüklüyse ya da yanlışlıkla bir oltalama web sitesini ziyaret ederseniz varlıklarınız çalınabilir.',
  'unlock.privateKey.enterYourPrivateKey': 'Özel anahtarınızı girin (hex formatında)',
  'unlock.privateKey.invalid':
    'Girdiğiniz Özel Anahtar doğru formatta değil ve geçersiz. Lütfen tekrar deneyin.',
  'unlock.privateKey.passwordInvalid': 'Şifre geçersiz. Lütfen tekrar deneyin.',
  'unlock.privateKey.warning': 'Kayıp bir keystore dosyasını ya da şifreyi geri getirmek için',
  'unlock.privateKey.warningQuestion':
    'Özel anahtarınızı herhangi bir web sitesine girmeniz çok tehlikelidir. Eğer tarayıcınızda zararlı uzantılar yüklüyse ya da yanlışlıkla bir oltalama web sitesini ziyaret ederseniz varlıklarınız çalınabilir.',
  'unlock.recover.content':
    'Cüzdan oluşturulurken size sunulan kurtarma cümlesini kullanarak cüzdanı geri getirin',
  'unlock.recover.download.button': 'İndir',
  'unlock.recover.downloadTitle': 'Keystore Dosyanızı İndirin',
  'unlock.recover.password.placeholder': 'Güçlü bir şifre girin',
  'unlock.recover.submit': 'Gönder',
  'unlock.recover.title': 'Bir Keystore Dosyasını Kurtarın',
  'unlock.recover.understand.continue': 'Bir Keystore Dosyasını Kurtarın',
  'unlock.recover.word.placeholder': 'Ara',
  'unlock.recover.wordlist.reset': 'Sıfırla',
  'unlock.recover.wordlistTitle': 'Lütfen soldaki listeden Hatırlatma Cümlenizi seçin',
  'unlock.support.wallets': ' ',
  'unlock.temporarySessionPassword': 'Geçici oturum şifresi',
  'unlock.thisIsNotAValidWalletFile': 'Bu geçerli bir cüzdan dosyası değil',
  'unlock.trezor.connectToTrezor': "Trezor'a Bağlan",
  'unlock.trezor.firmwareNotice':
    "Not: Cihazınızı Binance Chain'le kullanabilmek için lütfen en son Trezor yazılımına güncellediğinizden emin olun.",
  'unlock.trezor.notOnTestNet': 'Not: Trezor aygıtları artık Chrome ya da Firefox gerektiriyor ',
  'unlock.trezor.title': 'Bir Trezor Cihazı ile kilidi aç',
  'unlock.unlockWalletNow': 'Cüzdanın Kilidini Şimdi Aç',
  'unlock.walletConnect.notes':
    "Not: Trust Wallet ve CoolWallet Binance Chain Testnet'i desteklemiyor.",
  'unlock.walletConnect.recommendedWallet': 'Desteklenen uygulamalar arasında',
  'unlock.walletConnet.getTrustWallet': 'Trust Wallet Al',
  'unlock.walletConnet.qrCodeDesc1': 'WalletConnect QR Kodunu Al',
  'unlock.walletConnet.qrCodeDesc2': "Henüz WalletConnect'i destekleyen bir uygulamanız yok mu?",
  'unlock.walletConnet.showWalletQrCode':
    'Bu ekrandaki QR kodu kullanarak mobil cüzdanınızı buraya bağlayın',
  'unlock.walletConnet.title': 'Önerilen',
  'walletConnect.clickHereToUnlock': 'Başka bir cüzdanın kilidini açmak için buraya tıklayın',
  'walletConnect.error': 'WalletConnect Hatası',
  'walletConnect.errorOccur': 'Bir WalletConnect hatası meydana geldi',
  'walletConnect.pleaseEnsureOpenWorking':
    'Lütfen uygulamanın açık ve çalışır durumda olduğundan emin olun.',
  'walletConnect.pleaseUseAWalletConnect':
    "Lütfen yukarıdaki QR kodu taramak için WalletConnect'i destekleyen bir uygulama kullanın",
  'walletConnect.qrCode': 'WalletConnect QR kodu',
  'walletConnect.readyToConfirm': 'Lütfen Onaylayın',
  'walletConnect.readyToConfirmBody': 'Lütfen cüzdan uygulamasındaki işlemi onaylayın.',
  'walletconnect.notifycation.connectAgain': 'Tekrar bağlan',
  'walletconnect.notifycation.disconnectMessage': ' Mobil Cüzdanla bağlantı kesildi...',
  'walletconnect.notifycation.hide': 'Gizle',
  'local.secure.storage': 'Local Secure Storage',
  'local.keystore.replace.tips':
    'You already have a keystore file, make sure you have backed up before replace',
}
